/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmi_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. BMI doesn't distinguish muscle from fat, so it can misclassify athletes and others. It's a starting point, not a diagnosis.`)
};

const es_bmi_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. El IMC no distingue entre músculo y grasa, por lo que puede clasificar mal a atletas y otros. Es un punto de partida, no un diagnóstico.`)
};

const de_bmi_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. BMI unterscheidet nicht zwischen Muskel und Fett, daher kann es Athleten und andere falsch klassifizieren. Es ist ein Ausgangspunkt, keine Diagnose.`)
};

const nl_bmi_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. BMI maakt geen onderscheid tussen spier en vet, dus het kan atleten en anderen verkeerd classificeren. Het is een uitgangspunt, geen diagnose.`)
};

const fr_bmi_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. L'IMC ne distingue pas le muscle de la graisse, donc il peut mal classer les athlètes et d'autres. C'est un point de départ, pas un diagnostic.`)
};

const it_bmi_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. L'IMC non distingue il muscolo dal grasso, quindi può classificare male gli atleti e altri. È un punto di partenza, non una diagnosi.`)
};

const pt_br2_bmi_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. BMI não distingue músculo de gordura, portanto pode classificar incorretamente atletas e outros. É um ponto de partida, não um diagnóstico.`)
};

const pt_bmi_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. O IMC não distingue músculo de gordura, portanto pode classificar incorretamente atletas e outros. É um ponto de partida, não um diagnóstico.`)
};

const ja_bmi_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。BMIは筋肉と脂肪を区別しないため、アスリートや他の人を誤分類する可能性があります。これは出発点であり、診断ではありません。`)
};

const zh_bmi_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不是。BMI 无法区分肌肉和脂肪，因此可能会对运动员等人群做出错误分类。它只是一个起点，而不是诊断结果。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmi_hub_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmi_hub_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmi_hub_faq3_a", locale)
	if (locale === "en") return en_bmi_hub_faq3_a(inputs)
	if (locale === "es") return es_bmi_hub_faq3_a(inputs)
	if (locale === "de") return de_bmi_hub_faq3_a(inputs)
	if (locale === "nl") return nl_bmi_hub_faq3_a(inputs)
	if (locale === "fr") return fr_bmi_hub_faq3_a(inputs)
	if (locale === "it") return it_bmi_hub_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_bmi_hub_faq3_a(inputs)
	if (locale === "pt") return pt_bmi_hub_faq3_a(inputs)
	if (locale === "ja") return ja_bmi_hub_faq3_a(inputs)
	return zh_bmi_hub_faq3_a(inputs)
};